import * as Yup from 'yup';

export const rejectAgreementValidationSchema = ({ t }) => {
  return Yup.object().shape({
    reason: Yup.string().optional(),
  });
};
